/**
 * Welk scherm van de app een melding opent, uit waar ze over gaat (MOB-1).
 *
 * Een tik op een native pushmelding komt binnen met alleen `refModule` en `refId` (ADR-0038): er
 * staat geen URL in. Dezelfde keuzes als in de meldingenlijst (`app-notifications-page.tsx`), als
 * pad, zodat de app ook zonder die pagina weet waar ze heen moet. Een onbekende soort opent het
 * beginscherm: daar staat ook de noodmelding, die geen eigen pagina heeft.
 */
export function appPathFor(
  refModule: string | undefined,
  refId: string | undefined,
  type?: string,
): string {
  if (!refId) return '/app';
  const id = encodeURIComponent(refId);

  switch (refModule) {
    case 'communication':
      return `/app/posts/${id}`;
    // De escalatie gaat over wie nog moet bevestigen, niet over de inhoud (Stap 17).
    case 'reach':
      return `/app/team/berichten/${id}`;
    case 'shift-handover':
      return `/app/overdracht/${id}`;
    case 'messaging':
      return `/app/gesprekken/${id}`;
    case 'messaging_shared':
      return `/app/over-bedrijven/${id}`;
    // Een checklist: `refId` is de uitvoering.
    case 'tasks':
      return `/app/checklists/${id}`;
    // Een nieuwe melding is voor wie afhandelt; een gewijzigde stand voor de melder.
    case 'floor-reports':
      return type === 'floor_report_new' ? '/admin/meldingen' : '/app/melden';
    // Agenda en documenten hebben geen pagina per item; de lijst is de plek.
    case 'agenda':
      return '/app/agenda';
    case 'documents':
      return '/app/documenten';
    default:
      return '/app';
  }
}
